// extracted by mini-css-extract-plugin
export default {"container":"organization_container__E2drr"};